(() => {
const key = '__nutuTimersV1';
if (window[key]?.manualContextVersion === 4) { window[key].scan(); return; }
const legacyLoader = window[key];
if (legacyLoader) legacyLoader.destroy();
const selector = '[data-nutu-timer-id],[data-nutu-timers-global]';
const mounts = new Map(), groups = new Map(), modules = new Map();
let poll = null, queued = false, stopped = false;
const media = window.matchMedia('(max-width: 749px)');
function stack() {
  for(const reg of mounts.values()) if(reg.global) {
    for(const position of ['top','bottom']) {
      const items=[...reg.items.values()].filter(item=>item.host.dataset.nutuTimerPlacement===position);
      if(position==='bottom')items.reverse();
      let height=0;
      for(const item of items) {
        if(item.host.dataset.nutuBottomDock==='1')continue;
        if(item.host.style.position!=='sticky')continue;
        item.host.style[position]=`${height+item.offset}px`;
        if(!item.host.hidden)height+=item.offset+item.host.getBoundingClientRect().height;
      }
    }
    if(reg.bottomDock){const visible=[...reg.items.values()].some(item=>item.host.dataset.nutuBottomDock==='1'&&!item.host.hidden);reg.bottomDock.hidden=!visible;reg.bottomSpace.style.height=`${visible?reg.bottomDock.getBoundingClientRect().height:0}px`;}
  }
}
const sizes=new ResizeObserver(stack);
function endpoint(value) {
  try {
    const u = new URL(value, location.href);
    if (u.protocol !== 'https:' || u.username || u.password) return null;
    if (!u.pathname.endsWith('/api/timers')) u.pathname = '/api/timers';
    u.search = ''; u.hash = ''; return u;
  } catch { return null; }
}
function readContext(el) {
  let ctx = {};
  const provider = el.hasAttribute('data-nutu-context') ? el : document.querySelector('[data-nutu-timers-global][data-nutu-context]');
  try { ctx = JSON.parse((provider?.dataset.nutuContext || '{}').replace(/<!--[\s\S]*?-->/g, '').trim()); } catch {}
  return {...ctx, path: location.pathname, language: ctx.language || document.documentElement.lang || 'pl', device: media.matches ? 'mobile' : 'desktop'};
}
function renderer(url) {
  const href = new URL('/timer-renderer.mjs', url).href;
  if (!modules.has(href)) modules.set(href, import(href).catch(error => {modules.delete(href);throw error;}));
  return modules.get(href);
}
function clearRegistration(reg) {
  reg.disposed = true;
  reg.handle?.destroy();
  for (const item of reg.items.values()) {sizes.unobserve(item.host);item.handle?.destroy();item.host.remove();}
  reg.items.clear();
  if(reg.bottomDock){sizes.unobserve(reg.bottomDock);reg.bottomDock.remove();reg.bottomSpace.remove();}
}
function place(host, config) {
  const p = config.placement;
  host.style.display = 'block'; host.style.width = '100%'; host.style.boxSizing = 'border-box';
  host.style.position = p.sticky ? 'sticky' : 'relative';
  host.style.zIndex = p.sticky ? '20' : 'auto';
  host.style.top = p.position === 'top' && p.sticky ? `${p.offset || 0}px` : '';
  host.style.bottom = p.position === 'bottom' && p.sticky ? `${p.offset || 0}px` : '';
  host.style.marginTop = !p.sticky && p.position === 'top' ? `${p.offset || 0}px` : '';
  host.style.marginBottom = !p.sticky && p.position === 'bottom' ? `${p.offset || 0}px` : '';
  host.dataset.nutuTimerPlacement = p.position;
}

function centerPromo(reg) {
  if (reg.id !== 'ntt_9c5408adab64450b995cfe5672865c65') return;
  const root=reg.el.shadowRoot;
  if (!root || root.querySelector('[data-nutu-centered-promo]')) return;
  const style=document.createElement('style');
  style.setAttribute('data-nutu-centered-promo','');
  style.textContent=`
    .timer{display:flex!important;flex-direction:row!important;justify-content:center!important;align-items:center!important;gap:clamp(24px,4vw,64px)!important;max-width:none!important}
    .timer .copy{flex:0 1 auto;text-align:left;max-width:640px}
    .timer .clock{flex:0 0 auto}
    @media(max-width:749px){.timer{flex-direction:column!important;gap:6px!important;padding:8px 12px!important}.timer .copy{text-align:center;max-width:100%}.timer .title{font-size:13px!important;line-height:1.2!important}.timer .subtitle{font-size:10px!important;line-height:1.25!important;margin-top:2px!important}.timer .clock{max-width:100%;gap:3px!important}.timer .digit,.timer .separator{font-size:22px!important;line-height:1!important}.timer .unit{min-width:1.6em!important}.timer .label{font-size:8px!important;margin-top:2px!important}}
  `;
  root.append(style);
}

async function renderEntries(reg, entries, now) {
  const {mountTimer} = await renderer(reg.url);
  if (reg.disposed || !reg.el.isConnected) return;
  const context = {...readContext(reg.el), manual: !reg.global};
  if (!reg.global) {
    const entry = entries.find(item => item.id === reg.id);
    if (!entry) {reg.handle?.destroy();reg.handle=null;reg.el.hidden=true;return;}
    if (reg.handle) reg.handle.refresh(entry, {context, now});
    else reg.handle = mountTimer(reg.el, entry, {context, now});
    centerPromo(reg);
    return;
  }
  const live = new Set();
  for (const entry of entries) {
    if (entry.config.placement.manual || !['top','bottom'].includes(entry.config.placement.position)) continue;
    live.add(entry.id);
    let item = reg.items.get(entry.id);
    if (!item) {
      const host = document.createElement('div'); host.dataset.nutuTimerMounted = entry.id;
      item = {host, handle:null,offset:0}; reg.items.set(entry.id,item);sizes.observe(host);
    }
    const p=entry.config.placement.position;
    const dock=p==='bottom'&&entry.config.placement.sticky;
    const moved=item.host.dataset.nutuTimerPlacement!==p||item.host.dataset.nutuBottomDock!==(dock?'1':'0');
    if(!item.host.isConnected||moved) {
      if(dock){
        if(!reg.bottomDock){
          reg.bottomDock=document.createElement('div');reg.bottomSpace=document.createElement('div');
          reg.bottomDock.dataset.nutuTimerDock='bottom';reg.bottomSpace.setAttribute('aria-hidden','true');
          Object.assign(reg.bottomDock.style,{position:'fixed',bottom:'0',left:'0',right:'0',zIndex:'20',maxHeight:'40vh',overflow:'auto',paddingBottom:'env(safe-area-inset-bottom, 0px)'});
          document.body.append(reg.bottomSpace,reg.bottomDock);sizes.observe(reg.bottomDock);
        }
        reg.bottomDock.append(item.host);
      }else if(p==='top') {
        const previous=[...reg.items.values()].filter(other=>other!==item&&other.host.isConnected&&other.host.dataset.nutuTimerPlacement==='top').at(-1);
        if(previous)previous.host.after(item.host);else document.body.prepend(item.host);
      } else document.body.append(item.host);
    }
    place(item.host,entry.config);
    item.host.dataset.nutuBottomDock=dock?'1':'0';
    if(dock){item.host.style.position='relative';item.host.style.bottom='';item.host.style.marginBottom=`${Number(entry.config.placement.offset)||0}px`;}
    item.offset=Number(entry.config.placement.offset)||0;
    if(item.handle)item.handle.refresh(entry,{context,now});else item.handle=mountTimer(item.host,entry,{context,now});
  }
  for(const [id,item] of reg.items) if(!live.has(id)){sizes.unobserve(item.host);item.handle?.destroy();item.host.remove();reg.items.delete(id);}
  stack();
}
async function request(group, kind) {
  if(group.pending.has(kind)) return;
  const regs=[...group.regs].filter(reg=>!reg.disposed&&reg.global===(kind==='global'));
  if(!regs.length)return;
  const url=new URL(group.url);if(kind==='inline')url.searchParams.set('ids',[...new Set(regs.map(reg=>reg.id))].join(','));
  const abort=new AbortController();group.pending.set(kind,abort);
  const timeout=setTimeout(()=>abort.abort(),10000);
  try {
    const response=await fetch(url.href,{credentials:'omit',cache:'no-store',signal:abort.signal});
    if(!response.ok)throw new Error(`Timer HTTP ${response.status}`);
    const payload=await response.json();if(!Array.isArray(payload.timers))throw new Error('Invalid timer response');
    if(stopped||!groups.has(group.url))return;
    const now=typeof payload.serverNow==='number'?payload.serverNow:Date.parse(payload.serverNow);group.lastGood.set(kind,Date.now());
    for(const reg of regs)await renderEntries(reg,payload.timers,Number.isFinite(now)?now:Date.now());
  } catch(error) {
    if(!stopped&&Date.now()-(group.lastGood.get(kind)||group.createdAt)>90000)for(const reg of regs)await renderEntries(reg,[],Date.now()).catch(()=>{});
    if(window.Shopify?.designMode)console.warn('NUTU timer unavailable:',error.message);
  } finally {clearTimeout(timeout);group.pending.delete(kind);}
}
function reload() {
  if(stopped||document.hidden)return;
  for(const group of groups.values()){request(group,'global');request(group,'inline');}
}
function scan() {
  if(stopped)return;
  for(const [el,reg]of mounts)if(!el.isConnected){clearRegistration(reg);mounts.delete(el);const group=groups.get(reg.url);group?.regs.delete(reg);if(group&&!group.regs.size){for(const abort of group.pending.values())abort.abort();groups.delete(reg.url);}}
  let added=false;
  for(const el of document.querySelectorAll(selector)) {
    if(mounts.has(el))continue;
    const url=endpoint(el.dataset.nutuTimersEndpoint);if(!url)continue;
    const global=el.hasAttribute('data-nutu-timers-global');const id=el.dataset.nutuTimerId||'';
    if(!global&&!/^ntt_[a-f0-9]{32}$/.test(id))continue;
    if(global&&[...mounts.values()].some(reg=>reg.global&&reg.url===url.href))continue;
    const reg={el,id,global,url:url.href,items:new Map(),handle:null,disposed:false,bottomDock:null,bottomSpace:null};mounts.set(el,reg);
    let group=groups.get(reg.url);if(!group){group={url:reg.url,regs:new Set(),pending:new Map(),lastGood:new Map(),createdAt:Date.now()};groups.set(reg.url,group);}group.regs.add(reg);added=true;
  }
  if(groups.size&&!poll)poll=setInterval(reload,30000);
  if(!groups.size&&poll){clearInterval(poll);poll=null;}
  if(added)reload();
}
function queueScan(){if(!queued){queued=true;queueMicrotask(()=>{queued=false;scan();});}}
const observer=new MutationObserver(queueScan);
function start(){legacyLoader?.destroy();stopped=false;observer.observe(document.documentElement,{childList:true,subtree:true});scan();}
function destroy(){stopped=true;observer.disconnect();clearInterval(poll);poll=null;for(const reg of mounts.values())clearRegistration(reg);mounts.clear();for(const group of groups.values())for(const abort of group.pending.values())abort.abort();groups.clear();}
media.addEventListener('change',()=>{for(const reg of mounts.values()){if(reg.handle)reg.handle.refresh(undefined,{context:{...readContext(reg.el),manual:!reg.global}});for(const item of reg.items.values())item.handle?.refresh(undefined,{context:{...readContext(reg.el),manual:!reg.global}});}});
document.addEventListener('visibilitychange',()=>{if(!document.hidden)reload();});
document.addEventListener('shopify:section:load',queueScan);document.addEventListener('shopify:section:unload',queueScan);
document.addEventListener('nutu:timer-visibility',stack);
window.addEventListener('pagehide',destroy);window.addEventListener('pageshow',()=>{if(legacyLoader){destroy();start();}else if(stopped)start();});
window[key]={scan,destroy,manualContextVersion:4};
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
